//import DOMPurify from 'dompurify';
// envMixin.js
export default {
	computed: {
		loaderClass() {
		return process.env.LOADING_CLASS || '';
		},
	},
	data: () => ({
		passReq:"Password is required",
		passNotMatchErr:"Password can not be blank.",
		confPassReqErr:"Confirm password can not be blank",
		passLengthErr:"Password length should be greater than or equal to 8 character.",
		confPassMatchErr:"Password and Confirm Password do not match",
		ajxHeaders:{
			'Accept': 'application/json',
			"Authorization": "Bearer "+localStorage.getItem("tkn"),
			'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
			"Cache-Control": "no-cache"
		}
	}),
	methods: {

		safeHTML(html) {
			// Create a DOM element and set its innerHTML to the provided HTML
			const temp = document.createElement('span');
			temp.innerHTML = html;
			// Return the escaped content as text
			return temp.textContent || temp.innerText;
		},
		isValidURL(url) {

			let isUrl = false;
			// Implement URL validation logic here (customize based on your requirements)
			// For example, you can use regular expressions to validate URLs.
			let checkHash = url.charAt(0);
			if ( checkHash == "#" ) {
				const pattern = /^[0-9A-Za-z#]+$/;
				isUrl = pattern.test(url);
			} else {
				const urlPattern = /^(https?:\/\/)?[\w.-]+\.\w{2,6}(\/[\w .-]+)*$/;
				isUrl = urlPattern.test(url);
			}

			let result = "#";
			if ( isUrl ) {
				result = url;
			}

			return result 
		},
	}
};



// WEBPACK FOOTER //
// ./src/mixins/envMixins.js